export const GET_COUNTRY_LIST_REQUEST = 'GET_COUNTRY_LIST_REQUEST' as const;
export const GET_COUNTRY_LIST_SUCCESS = 'GET_COUNTRY_LIST_SUCCESS' as const;
export const GET_COUNTRY_LIST_ERROR = 'GET_COUNTRY_LIST_ERROR' as const;

export const CLOSE_ERROR_POPUP_COUNTRY_LIST = 'CLOSE_ERROR_POPUP_COUNTRY_LIST' as const;
